import React from 'react'
import SvgIcon from '@mui/material/SvgIcon'
import { SVGIconProps } from 'commonTypes'

const DnaIcon: React.FC<SVGIconProps> = ({ fill, ...props }) => {
    return (
        <SvgIcon viewBox="0 0 24 24" {...props}>

            <g opacity="0.5">
                <path
                    fill={fill ?? '#09293E'}
                    d="
                        M7.2 2.4
                        c3.1 2.1 6.5 4.4 9.6 6.5
                        1.7 1.2 2.7 2.5 2.7 4.1
                        s-1 2.9-2.7 4.1
                        c-3.1 2.1-6.5 4.4-9.6 6.5
                        l-1.1-1.7
                        c1.4-.9 2.8-1.9 4.2-2.8
                        H7
                        v-2
                        h6.2
                        l2.5-1.7
                        H9.5
                        v-2
                        h8
                        c.1-.3.1-.5.1-.8
                        s0-.5-.1-.8
                        h-8
                        v-2
                        h6.2
                        l-2.5-1.7
                        H7
                        v-2
                        h3.3
                        c-1.4-.9-2.8-1.9-4.2-2.8
                        l1.1-1.7
                        Z

                        M17.2 1.8
                        c-3.2 2.2-6.7 4.5-9.9 6.7
                        C5.6 9.7 4.5 11.2 4.5 13
                        s1 2.9 2.7 4.1
                        c3.1 2.1 6.5 4.4 9.6 6.5
                        l1.1-1.7
                        c-2.8-1.9-5.9-4-8.9-6
                        c-1.7-1.2-2.5-2-2.5-2.9
                        s.8-1.7 2.5-2.9
                        c2.9-2 6.1-4.1 9.2-6.2
                        l-1-2.1
                        Z
                    "
                />
            </g>
        </SvgIcon>
    )
}

export default DnaIcon